"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var EyeOff_exports = {};
__export(EyeOff_exports, {
  default: () => EyeOff_default
});
module.exports = __toCommonJS(EyeOff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.677 3.077a.5.5 0 0 1 .707 0L20.6 19.293a.5.5 0 0 1-.707.707L3.677 3.784a.5.5 0 0 1 0-.707Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.727 6.434C6.5 7.067 5.503 7.914 4.725 8.75a13.865 13.865 0 0 0-2.128 3.023 7.898 7.898 0 0 0-.135.277l-.008.018-.002.005v.002l.548.242-.55-.241a.6.6 0 0 0 .01.503l.54-.262-.54.262.001.002.001.001.003.005.008.016.028.056c.025.047.06.114.108.197.095.167.235.402.423.683.375.56.942 1.305 1.715 2.051C6.294 17.083 8.685 18.6 12 18.6c2.502 0 4.479-.863 5.963-1.93l-.861-.86A8.842 8.842 0 0 1 12 17.398c-2.916 0-5.024-1.325-6.42-2.673a11.528 11.528 0 0 1-1.55-1.855 9.64 9.64 0 0 1-.355-.57 12.664 12.664 0 0 1 1.928-2.734c.784-.84 1.787-1.668 3.023-2.234l-.898-.898Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m8.705 5.998.945.945A8.07 8.07 0 0 1 12 6.6c2.893 0 4.995 1.461 6.398 2.967a12.669 12.669 0 0 1 1.928 2.734 9.635 9.635 0 0 1-.354.569 11.53 11.53 0 0 1-2.07 2.325l.851.85a12.723 12.723 0 0 0 2.215-2.508 10.7 10.7 0 0 0 .531-.88l.029-.055.008-.016.002-.005.001-.001s0-.002-.539-.264l.54.262a.6.6 0 0 0 .01-.503l-.55.24.55-.24v-.002l-.002-.001-.002-.005-.008-.018-.028-.06a12.045 12.045 0 0 0-.526-.97 13.86 13.86 0 0 0-1.708-2.27c-1.54-1.653-3.938-3.35-7.276-3.35-1.223 0-2.32.229-3.295.599Zm11.746 6.56Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M10.184 8.89a3.6 3.6 0 1 0 4.925 4.925l-.893-.892a2.4 2.4 0 1 1-3.139-3.14l-.893-.892Z"
    }
  )
);
const SvgEyeOff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var EyeOff_default = SvgEyeOff;
